import { render, staticRenderFns } from "./CallForPay.vue?vue&type=template&id=70cfd7a7&scoped=true&"
import script from "./CallForPay.vue?vue&type=script&lang=js&"
export * from "./CallForPay.vue?vue&type=script&lang=js&"
import style0 from "./CallForPay.vue?vue&type=style&index=0&id=70cfd7a7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfd7a7",
  null
  
)

export default component.exports